module.exports = __webpack_public_path__ + "static/media/3219A3_0_0.f26b16e4.ttf";